export const INACTIVE_TIMEOUT_MS = 5 * 60 * 1000; // 5 mins
export const INACTIVE_PROMPT_ADVANCE_MS = 1 * 60 * 1000; // 2 min
export const ACTIVITY_EVENT_THROTTLE_MS = 10 * 1000;
